module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1173840"
    }
  }, [_c('b', [_vm._v("TOMATO AND RICOTTA SALATA "), _c('br'), _vm._v(" BRUSCHETTA")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1174640"
    }
  }, [_c('b', [_c('i', [_vm._v("Bruschetta is toasted Italian bread that is rubbed with garlic and drizzled with olive oil. It’s often topped with savory ingredients to make a simple appetizer. Here we use ripe tomatoes and ricotta salata, a lightly salted and pressed sheep’s milk cheese. Ricotta salata can be found at Italian markets and specialty food stores.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1177140"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1177640"
    }
  }, [_vm._v("1 loaf (8 ounces) Italian bread, cut on diagonal "), _c('br'), _vm._v(" into ½-inch-thick slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1179040"
    }
  }, [_vm._v("8 garlic cloves, each cut in half")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1179340"
    }
  }, [_vm._v("1 pound ripe plum tomatoes (6 medium), seeded "), _c('br'), _vm._v(" and cut into ½-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1180840"
    }
  }, [_vm._v("1 tablespoon finely chopped red onion")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1181140"
    }
  }, [_vm._v("1 tablespoon chopped fresh basil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1181540"
    }
  }, [_vm._v("4 ounces ricotta salata, feta, or goat cheese, "), _c('br'), _vm._v(" cut into ½-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1182940"
    }
  }, [_vm._v("2 tablespoons extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1183240"
    }
  }, [_vm._v("2 teaspoons balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1183640"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1184540"
    }
  }, [_vm._v("¼ teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1185640"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 400°F. Place bread slices on cookie sheet and bake until lightly toasted, about 5 minutes. Rub one side of each toast slice with cut side of garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1187340"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, in bowl, gently toss tomatoes, onion, basil, cheese, oil, vinegar, salt, and pepper until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1188640"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" To serve, spoon tomato mixture on garlic-rubbed side of toast slices. Makes 16 bruschetta.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1190040"
    }
  }, [_vm._v("Each bruschetta: About 79 calories, 2g protein, 9g carbohydrate, 4g total fat (1g saturated), 6mg cholesterol, 236mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1191040"
    }
  }, [_c('b', [_vm._v("TUSCAN WHITE-BEAN BRUSCHETTA")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1191540"
    }
  }, [_vm._v("Prepare toast as directed but prepare topping as follows: In bowl, with fork, lightly mash "), _c('b', [_vm._v("1 can (15½ to 19 ounces) white kidney beans (cannellini), ")]), _vm._v("rinsed and drained, with "), _c('b', [_vm._v("1 tablespoon fresh lemon juice.")]), _vm._v(" Stir in "), _c('b', [_vm._v("1 tablespoon olive oil, 2 teaspoons chopped fresh parsley, 1 teaspoon minced fresh sage, ¼ teaspoon salt, ")]), _vm._v("and "), _c('b', [_vm._v("⅛ teaspoon coarsely ground black pepper. ")]), _vm._v("Just before serving, spoon mixture over garlic-rubbed side of toast slices. Sprinkle with "), _c('b', [_vm._v("1 teaspoon chopped fresh parsley. ")]), _vm._v("Makes 16 bruschetta.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1199240"
    }
  }, [_vm._v("Each bruschetta: About 33 calories, 2g protein, 4g carbohydrate, 1g total fat (0g saturated), 0mg cholesterol, 77mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f9390fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c28_r1.vue
// module id = 150
// module chunks = 0